(function () {
  'use strict';

  var initializedSections = new WeakSet();

  function lockScroll() {
    document.documentElement.classList.add('rabitat-scroll-lock');
    document.body.classList.add('rabitat-scroll-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('rabitat-scroll-lock');
    document.body.classList.remove('rabitat-scroll-lock');
  }

  function paramsFromForm(form) {
    var params = new URLSearchParams();
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      if (String(value).trim() !== '') {
        params.append(key, value);
      }
    });

    return params;
  }

  function paramsFromUrl(url) {
    var parsed = new URL(url, window.location.origin);
    return parsed.searchParams;
  }

  function buildSectionUrl(collectionUrl, sectionId, params) {
    var url = new URL(collectionUrl, window.location.origin);
    url.search = '';
    url.searchParams.set('section_id', sectionId);

    params.forEach(function (value, key) {
      if (key !== 'section_id') {
        url.searchParams.append(key, value);
      }
    });

    return url.toString();
  }

  function buildDisplayUrl(collectionUrl, params) {
    var url = new URL(collectionUrl, window.location.origin);

    url.search = '';
    params.forEach(function (value, key) {
      if (key === 'section_id') return;
      url.searchParams.append(key, value);
    });

    return url.pathname + url.search;
  }

  function initProductCards() {
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
  }

  function renderCollectionSection(sectionWrap, params, options) {
    var opts = options || {};
    var sectionId = sectionWrap.getAttribute('data-section-id');
    var collectionUrl = opts.collectionUrl || sectionWrap.getAttribute('data-collection-url');
    var dynamic = sectionWrap.querySelector('[data-collection-dynamic]');

    if (!sectionId || !collectionUrl || !dynamic) {
      return Promise.resolve();
    }

    sectionWrap.classList.add('is-loading');

    return fetch(buildSectionUrl(collectionUrl, sectionId, params), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Collection request failed');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var nextDynamic = doc.querySelector('[data-collection-dynamic]');

        if (!nextDynamic) throw new Error('Collection section markup missing');

        dynamic.innerHTML = nextDynamic.innerHTML;
        sectionWrap.setAttribute('data-collection-url', collectionUrl);

        if (opts.updateHistory !== false && window.history && window.history.pushState) {
          window.history.pushState(
            { collectionUrl: collectionUrl, collectionParams: params.toString() },
            '',
            buildDisplayUrl(collectionUrl, params)
          );
        }

        initProductCards();
      })
      .catch(function () {
        window.location.href = buildDisplayUrl(collectionUrl, params);
      })
      .finally(function () {
        sectionWrap.classList.remove('is-loading');
      });
  }

  function getFilterDrawer(sectionWrap) {
    return sectionWrap.querySelector('[data-collection-filter-drawer]');
  }

  function getSortMenu(sectionWrap) {
    return sectionWrap.querySelector('[data-collection-sort-menu]');
  }

  function openFilterDrawer(sectionWrap) {
    var filterDrawer = getFilterDrawer(sectionWrap);
    var filterOpen = sectionWrap.querySelector('[data-collection-filter-open]');
    if (!filterDrawer) return;

    filterDrawer.hidden = false;
    filterDrawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      filterDrawer.classList.add('is-open');
    });
    if (filterOpen) filterOpen.setAttribute('aria-expanded', 'true');
    lockScroll();
  }

  function closeFilterDrawer(sectionWrap) {
    var filterDrawer = getFilterDrawer(sectionWrap);
    var filterOpen = sectionWrap.querySelector('[data-collection-filter-open]');
    if (!filterDrawer) return;

    filterDrawer.classList.remove('is-open');
    filterDrawer.setAttribute('aria-hidden', 'true');
    if (filterOpen) filterOpen.setAttribute('aria-expanded', 'false');
    unlockScroll();

    window.setTimeout(function () {
      if (!filterDrawer.classList.contains('is-open')) {
        filterDrawer.hidden = true;
      }
    }, 280);
  }

  function closeSortMenu(sectionWrap) {
    var sortMenu = getSortMenu(sectionWrap);
    var sortToggle = sectionWrap.querySelector('[data-collection-sort-toggle]');
    if (!sortMenu || !sortToggle) return;

    sortMenu.hidden = true;
    sortToggle.setAttribute('aria-expanded', 'false');
  }

  function toggleSortMenu(sectionWrap) {
    var sortMenu = getSortMenu(sectionWrap);
    var sortToggle = sectionWrap.querySelector('[data-collection-sort-toggle]');
    if (!sortMenu || !sortToggle) return;

    var willOpen = sortMenu.hidden;
    sortMenu.hidden = !willOpen;
    sortToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function initCollectionSection(sectionWrap) {
    if (initializedSections.has(sectionWrap)) return;
    initializedSections.add(sectionWrap);

    sectionWrap.addEventListener('click', function (event) {
      var filterOpen = event.target.closest('[data-collection-filter-open]');
      var filterClose = event.target.closest('[data-collection-filter-close]');
      var sortToggle = event.target.closest('[data-collection-sort-toggle]');
      var sortOption = event.target.closest('.rabitat-collection-page__sort-option');
      var pageLink = event.target.closest('[data-collection-page-link]');
      var tabLink = event.target.closest('[data-collection-tab]');
      var clearAll = event.target.closest('[data-collection-clear-all]');
      var sortWrap = sectionWrap.querySelector('[data-collection-sort]');

      if (tabLink && sectionWrap.contains(tabLink)) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();

        if (tabLink.classList.contains('is-active') || tabLink.getAttribute('aria-current') === 'page') {
          return;
        }

        var tabUrl = new URL(tabLink.href, window.location.origin);
        closeSortMenu(sectionWrap);
        closeFilterDrawer(sectionWrap);
        renderCollectionSection(sectionWrap, tabUrl.searchParams, {
          collectionUrl: tabUrl.pathname
        });
        return;
      }

      if (filterOpen && sectionWrap.contains(filterOpen)) {
        event.preventDefault();
        openFilterDrawer(sectionWrap);
        return;
      }

      if (filterClose && sectionWrap.contains(filterClose)) {
        event.preventDefault();
        closeFilterDrawer(sectionWrap);
        return;
      }

      if (sortToggle && sectionWrap.contains(sortToggle)) {
        event.preventDefault();
        event.stopPropagation();
        toggleSortMenu(sectionWrap);
        return;
      }

      if (sortOption && sectionWrap.contains(sortOption)) {
        event.preventDefault();
        var sortForm = sortOption.closest('[data-collection-sort-form]');
        if (!sortForm) return;

        var params = paramsFromForm(sortForm);
        params.set('sort_by', sortOption.value);
        closeSortMenu(sectionWrap);
        renderCollectionSection(sectionWrap, params);
        return;
      }

      if (pageLink && sectionWrap.contains(pageLink)) {
        event.preventDefault();
        closeSortMenu(sectionWrap);
        renderCollectionSection(sectionWrap, paramsFromUrl(pageLink.href));
        return;
      }

      if (clearAll && sectionWrap.contains(clearAll)) {
        event.preventDefault();
        var filterForm = sectionWrap.querySelector('[data-collection-filter-form]');
        var params = new URLSearchParams();
        if (filterForm) {
          var sortInput = filterForm.querySelector('[name="sort_by"]');
          if (sortInput && sortInput.value) {
            params.set('sort_by', sortInput.value);
          }
        }
        closeFilterDrawer(sectionWrap);
        renderCollectionSection(sectionWrap, params);
        return;
      }

      if (sortWrap && !sortWrap.contains(event.target)) {
        closeSortMenu(sectionWrap);
      }
    });

    sectionWrap.addEventListener('submit', function (event) {
      var filterForm = event.target.closest('[data-collection-filter-form]');
      if (!filterForm || !sectionWrap.contains(filterForm)) return;

      event.preventDefault();
      closeFilterDrawer(sectionWrap);
      renderCollectionSection(sectionWrap, paramsFromForm(filterForm));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeFilterDrawer(sectionWrap);
      closeSortMenu(sectionWrap);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-collection-section]').forEach(initCollectionSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionWrap = event.target.querySelector('[data-collection-section]');
    if (sectionWrap) initCollectionSection(sectionWrap);
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-collection-section]').forEach(function (sectionWrap) {
      var url = new URL(window.location.href);
      renderCollectionSection(sectionWrap, url.searchParams, {
        collectionUrl: url.pathname,
        updateHistory: false
      });
    });
  });
})();
